import React, { Component } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import HomeNav from "components/Navbars/HomeNav.js";
import Pagination from 'react-bootstrap/Pagination';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import {Formik, Field, Form} from 'formik';

// reactstrap components
import {
  Card,
  CardBody,  
  Container,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,  
} from "reactstrap";

// core components
import HomePageHeader from "components/Headers/HomePageHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
import { allDonorsFetchAction,fetchDonorByPhoneAction } from 'actions/donorActions';

class LiquidLoveDonors extends Component {
  constructor(props) {
    super(props);
    this.state ={
      firstFocus: '',
      lastFocus: '',
      resultSize: 10,
      filter: 'All',
      fetchByPhone: false,
      isActiveDonors: 'All'
    }
    this.handleDonorClick = this.handleDonorClick.bind(this);
    this.constructPaginationLinks = this.constructPaginationLinks.bind(this);
    this.pageChanged = this.pageChanged.bind(this);
    this.sizeChanged = this.sizeChanged.bind(this);
    this.activeChanged = this.activeChanged.bind(this);
  }

  handleDonorClick(rowIndex, donorPhone) {
    if(this.props.response.login.isSuperAdmin || this.props.response.login.isStateAdmin)
      this.props.navigate('/liquidlove/donor?accessMode=admin&rowIndex=' + rowIndex);
    else //normal admin 
      this.props.navigate('/liquidlove/donor?accessMode=admin&donorPhone=' + donorPhone);
  }

  componentWillMount() {
    document.title = 'Liquid Love Donors';
    document.body.classList.add("landing-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
   
    if(!this.props.response.login.isSignedIn)
      this.props.response.login.redirectAfterSignInTo = '/liquidlove/donors';         //user not logged in..redirect to login page
    else if ((this.props.response.login.isSuperAdmin || 
      this.props.response.login.isStateAdmin)){
      const payload = { 
        pageNum: 0,
        size: this.state.resultSize,
        filter: this.state.filter,
        isActive: this.state.isActiveDonors,
        token: this.props.response.login.userToken
      }
      this.props.dispatch(allDonorsFetchAction(payload));
    }
  }
  componentWillUnmount() {
    document.body.classList.remove("landing-page");
    document.body.classList.remove("sidebar-collapse");
    this.props.response.donor.noServiceResponse = false;
  }

  constructPaginationLinks(totalPages,currentPage) {
    let items = [];
    if (totalPages === 1 || totalPages === 0) {
      return items;
    }

    if (totalPages > 3) {      
      if (currentPage > 0) {
        items.push(
          <Pagination.Item key={1}>{1}</Pagination.Item>
        );
        if(currentPage != 1){
          items.push(
            <Pagination.Ellipsis />
          );
          items.push(
            <Pagination.Item key={currentPage}>{currentPage}</Pagination.Item> 
          );
        }
      }
      //Current page
      items.push(
        <Pagination.Item key={currentPage +1} active>
          {currentPage +1}
        </Pagination.Item> 
      );

      if (currentPage < totalPages -1) {
        items.push(
          <Pagination.Item key={currentPage +2}>{currentPage +2}</Pagination.Item>
        );
        if(currentPage < totalPages -2){
          items.push(
            <Pagination.Ellipsis />
          );
          items.push(
            <Pagination.Item key={totalPages}>{totalPages}</Pagination.Item>
          );
        }
      }      
      return items;
    }
    
    for (let number = 0; number < totalPages; number++) {
      let index = number + 1;

      items.push(
        <Pagination.Item key={index} active={index === (currentPage) + 1}>
          {index}
        </Pagination.Item>
      );
    }
    return items;
  }

  pageChanged(e) {
    let index = e.target.text;

    const payload = { 
      pageNum: parseInt(index -1),
      size: this.state.resultSize,
      filter: this.state.filter,
      isActive: this.state.isActiveDonors,
      token: this.props.response.login.userToken
    }
    this.props.dispatch(allDonorsFetchAction(payload));
  }

  sizeChanged(e){
    this.state.resultSize = parseInt(e.target.text);
    const payload = { 
      pageNum: 0,
      size: this.state.resultSize,
      filter: this.state.filter,
      isActive: this.state.isActiveDonors,
      token: this.props.response.login.userToken
    }
    this.props.dispatch(allDonorsFetchAction(payload));
  }

  activeChanged(e){
    this.state.isActiveDonors = e.target.attributes.href.value;    
    const payload = { 
      pageNum: 0,
      size: this.state.resultSize,
      filter: this.state.filter,
      isActive: this.state.isActiveDonors,
      token: this.props.response.login.userToken
    }
    this.props.dispatch(allDonorsFetchAction(payload));
  }

  onKeyDown(keyEvent) {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      keyEvent.preventDefault();
    }
  }

  render() {    
    let message = '';
    let totalPages = 0;
    let currentPage = 0;
    if(this.props.response.donor.hasOwnProperty('allDonors') &&
    this.props.response.donor.allDonors !== undefined){
      if(this.props.response.donor.allDonors.hasOwnProperty('error')){
        if(this.props.response.donor.allDonors.status === 401){
          message = 'Your session has expired. Please login again'
        }
        else
          message = 'Sairam! Sorry. We are not able to process your request.'
      }
      else{
        totalPages = this.props.response.donor.allDonors.totalPages;
        currentPage = this.props.response.donor.allDonors.number;
      }  
    }
    
    if(!this.props.response.login.isSignedIn) 
        return <Navigate to={'/liquidlove/login'} />
    
    if(this.props.response.donor.noServiceResponse)
        message = 'Sairam. Sorry! We are not able to get the details. Please try later.';
    
    let countMsg1 = this.state.isActiveDonors === 'Y' ? 'Active' : 
      this.state.isActiveDonors === 'N' ? 'In Active' : 
        (this.state.isActiveDonors === 'R' ? 'Review' : 'All') ;
    let countMsg2 = ' donors filtered by ';
    let countMsg3 = (this.state.filter === 'All' || this.state.filter === '') ? 'none' : this.state.filter; 
    let countMsg4 = ' count: '; 
    let countMsg5 = this.props.response.donor.hasOwnProperty('allDonors') ? 
                this.props.response.donor.allDonors.totalElements : '';
    let countMsg = countMsg1 + countMsg2 + countMsg3 + countMsg4 + countMsg5;

    return (      
          <div className="wrapper">
            <HomePageHeader /><HomeNav adminName={this.props.response.login.adminName}/>
            <div
              style={{
                backgroundImage: "url(" + require("assets/img/shivaratri-wallpapers-6.png") + ")",
                backgroundSize: "cover",
                backgroundPosition: "top center",
                minHeight: "700px",
              }}
            >
            <Container>
              <Card>
                <CardBody align="center" tag="h6">Liquid Love Donors</CardBody>
              </Card>
              <div style={{color: "white"}}>{message}</div>
                <Formik
        initialValues={{
          filter: 'All|Name|DOB|Blood group',
          phone: 'phone number'
        }}        
        onSubmit={fields => {
          if(this.state.fetchByPhone){
            this.state.fetchByPhone = false;
            const payload = { 
              pageNum: 0,
              size: this.state.resultSize,
              phone: fields.phone,
              token: this.props.response.login.userToken
            }
            this.props.dispatch(fetchDonorByPhoneAction(payload));
          }
          else{
            this.state.filter = fields.filter === 'All|Name|DOB|Blood group' ? 'All' : fields.filter

            const payload = { 
              pageNum: 0,
              size: this.state.resultSize,
              filter: this.state.filter,
              isActive: this.state.isActiveDonors,
              token: this.props.response.login.userToken
            }
            this.props.dispatch(allDonorsFetchAction(payload));
          }
        }
    }
    
        render={({ errors, status, touched }) => (                             
          <Form onKeyDown={this.onKeyDown}>
            <Field name="phone" type="text" />
            <button onClick={e => {this.state.fetchByPhone = true}} className="btn btn-primary btn-icon btn-round">
              <i className="now-ui-icons ui-1_zoom-bold mr-1"></i>
            </button>&nbsp;&nbsp;
            <Field disabled={!(this.props.response.login.isSuperAdmin || this.props.response.login.isStateAdmin)} name="filter" type="text"/>
            <button disabled={!(this.props.response.login.isSuperAdmin || this.props.response.login.isStateAdmin)} type="submit" className="btn btn-primary btn-icon btn-round">
              <i className="now-ui-icons ui-1_zoom-bold mr-1"></i>
            </button>&nbsp;&nbsp;
            <UncontrolledDropdown disabled={!(this.props.response.login.isSuperAdmin || this.props.response.login.isStateAdmin)} className="btn-group" size="sm">
                <DropdownToggle
                  aria-expanded={false}
                  aria-haspopup={true}
                  caret
                  color="primary"
                  data-toggle="dropdown"
                  type="button"
                >
                  Active
                </DropdownToggle>
                <DropdownMenu disabled={!(this.props.response.login.isSuperAdmin || this.props.response.login.isStateAdmin)}>
                  <DropdownItem  href="All" onClick={e => {e.preventDefault(); this.activeChanged(e)}}>All</DropdownItem>
                  <DropdownItem  href="Y" onClick={e => {e.preventDefault(); this.activeChanged(e)}}>Active</DropdownItem>
                  <DropdownItem  href="N" onClick={e => {e.preventDefault(); this.activeChanged(e)}}>In Active</DropdownItem>
                  <DropdownItem  href="R" onClick={e => {e.preventDefault(); this.activeChanged(e)}}>Review</DropdownItem>
                </DropdownMenu>                
              </UncontrolledDropdown>
              &nbsp;&nbsp;
            <UncontrolledDropdown disabled={!(this.props.response.login.isSuperAdmin || this.props.response.login.isStateAdmin)} className="btn-group" size="sm">
                <DropdownToggle
                  aria-expanded={false}
                  aria-haspopup={true}
                  caret
                  color="primary"
                  data-toggle="dropdown"
                  type="button"
                >
                  Size
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem  href="10" onClick={e => {e.preventDefault(); this.sizeChanged(e)}}>10</DropdownItem>
                  <DropdownItem  href="30" onClick={e => {e.preventDefault(); this.sizeChanged(e)}}>30</DropdownItem>
                  <DropdownItem  href="60" onClick={e => {e.preventDefault(); this.sizeChanged(e)}}>60</DropdownItem>
                  <DropdownItem  href="100" onClick={e => {e.preventDefault(); this.sizeChanged(e)}}>100</DropdownItem>
                </DropdownMenu>                
                </UncontrolledDropdown>
          </Form>
          )}
          />
          <div style={{color: "white"}}>
            {(this.props.response.donor.hasOwnProperty('findByPhone') && 
                this.props.response.donor.findByPhone) ? '' : countMsg }                          
          </div>
              <TableContainer component={Paper}>
                <Pagination size="sm" onClick={(event) => this.pageChanged(event)} >{this.constructPaginationLinks(totalPages,currentPage)}</Pagination>                                                
                <Table className="table" size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                        <TableCell align="right">Donor Name</TableCell>
                        <TableCell align="right">Phone</TableCell> 
                        <TableCell align="right">Blood&nbsp;Group</TableCell>
                        <TableCell align="right">Last Donated</TableCell>
                        <TableCell align="right">Ailments</TableCell>                      
                        <TableCell align="right">DOB</TableCell>
                        <TableCell align="right">Gender</TableCell>
                        <TableCell align="right">Address</TableCell>
                        <TableCell align="right">District</TableCell>
                        <TableCell align="right">PinCode</TableCell>
                        <TableCell align="right">Height(cms)</TableCell>
                        <TableCell align="right">Weight(kgs)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  {this.props.response.donor.allDonors && this.props.response.donor.allDonors.content ? this.props.response.donor.allDonors.content.map((row,index) => (
                      <TableRow key={row.id} onClick={() => this.handleDonorClick(index,row.phone) }>
                        <TableCell align="right">{row.fullname}</TableCell>
                        <TableCell align="right">{row.phone}</TableCell>                        
                        <TableCell align="right">{row.bloodGroup}</TableCell>
                        <TableCell align="right">{row.lastDonatedOn}</TableCell>
                        <TableCell align="right">{row.ailments ? row.ailments.join(' | ') : 'None'}</TableCell>                        
                        <TableCell align="right">{row.dateOfBirth}</TableCell>
                        <TableCell align="right">{row.gender}</TableCell>
                        <TableCell align="right">{row.address}</TableCell>
                        <TableCell align="right">{row.district}</TableCell>
                        <TableCell align="right">{row.pincode}</TableCell>
                        <TableCell align="right">{row.height}</TableCell>
                        <TableCell align="right">{row.weight}</TableCell>
                      </TableRow>
                    )) : ''}
                  </TableBody>
                </Table>
                <Pagination size="sm" onClick={(event) => this.pageChanged(event)} >{this.constructPaginationLinks(totalPages,currentPage)}</Pagination>                
              </TableContainer>
              <div style={{color: "white"}}>{message}</div><br></br>
            </Container>                
          </div>
          <DefaultFooter />
        </div>
        )}
};

const mapStateToProps = (response) => ({response});

export default connect(mapStateToProps)((props) => {
  const navigate = useNavigate();
  return <LiquidLoveDonors navigate={navigate} {...props} />
});